export enum ModuleName {
    PakietPodstawowy = 'PakietPodstawowy',
    Fiskalizacja = 'Fiskalizacja',
    UzytkownikPlus = 'UzytkownikPlus',
    Magazyn = 'Magazyn'
}
